import Cookies from 'js-cookie';
import cottonFlagManager from './featureFlags/cotton';

export const ALLOWED_AUTH_SESSIONS = ['LOGIN FULL'];

export default ALLOWED_AUTH_SESSIONS;

const FORCE_LOGIN_PROMPT = 'select_billing_account login';
const PASSIVE_LOGIN_PROMPT = 'select_billing_account_auto';

const buildAuthQuery = prompt => new URLSearchParams({
  prompt,
  continue: window.location.href,
}).toString();

const getForceAuthBasePath = () => {
  const { disableRubyApis } = cottonFlagManager;
  return disableRubyApis ? '/cotton' : '';
};

const getPassiveAuthBasePath = () => {
  const { oauthEnabled, disableRubyApis } = cottonFlagManager;
  return (disableRubyApis || oauthEnabled) ? '/cotton' : '';
};

export const forceLoginV1 = ({ basePath } = {}) => {
  const resolvedBasePath = typeof basePath === 'string' ? basePath : getForceAuthBasePath();
  const { origin } = window.location;
  const authQuery = buildAuthQuery(FORCE_LOGIN_PROMPT);
  // Send the browser to the CIMA login screen after we destroy the MAW session.
  const forceConnectUrl = encodeURIComponent(`${origin}${resolvedBasePath}/oauth/v1/force_connect?${authQuery}`);
  window.location.replace(`${resolvedBasePath}/oauth/disconnect?continue=${forceConnectUrl}`);
};


export const passiveLoginV1 = ({ basePath } = {}) => {
  const resolvedBasePath = typeof basePath === 'string' ? basePath : getPassiveAuthBasePath();
  const authQuery = buildAuthQuery(PASSIVE_LOGIN_PROMPT);
  window.location.replace(`${resolvedBasePath}/oauth/v1/passive_connect?${authQuery}`);
};

export const isAptEnabled = () => cottonFlagManager.isAptV1Enabled;

export const hasHintCookie = () => !!Cookies.get('r-hint');
